import { Badge } from '@/components/base/badge'
import { Field, Label } from '@/components/base/fieldset'
import { Input } from '@/components/base/input'
import { Select } from '@/components/base/select'
import { StepActionsContext } from '@/helpers/useTestDefinition'
import { Handle, Position, type Node, type NodeProps } from '@xyflow/react'
import { useContext } from 'react'

type NoopNode = Node<{ name: string, steppable: { result: boolean } }, 'NoopTestStepType'>

export const NoopNode = ({ id, data }: NodeProps<NoopNode>) => {
  const { changeStep } = useContext(StepActionsContext)

  return (
    <div>
      <div className="text-white border border-zinc-500 rounded-lg p-4 bg-zinc-800/75 w-100">
        <div className="grid grid-cols-1 gap-2 items-center justify-around h-full">
          <div className="text-center"><Badge color="zinc">No operation</Badge></div>
          <Field>
            <Label>Name</Label>
            <Input value={ data.name } onChange={ e => changeStep(id, { name: e.target.value }) } />
          </Field>
          <Field>
            <Label>Result</Label>
            <Select value={ data.steppable.result ? 'Pass' : 'Fail' } onChange={ e => changeStep(id, { steppable: { result: e.target.value === 'Pass' ? true : false } }) }>
              <option value="Pass">Pass</option>
              <option value="Fail">Fail</option>
            </Select>
          </Field>
        </div>
      </div>
      <Handle position={ Position.Top } type="source" />
      <Handle position={ Position.Bottom } type="target" />
    </div>
  )
}
